import React, { useState, useMemo, useContext } from 'react';
import { Box, Grid } from '@mui/material';
import { toast } from 'react-toastify';
import moment from 'moment';
import { getProductSamplingMaintenanceInventoryReport } from '../../api/productSamplingMaintenanceAPI';
import Filter from './components/Filter';
import useSamplingContext from './context/useSamplingContext';
import Table from './components/Table';
import TotalTable from './components/TotalTable';
// CONTEXT
import AppConst from '../../components/AppLayout/const';

export default function ProductSamplingInventoryReport() {
  const defaultFilter = {
    department: '',
    team: { label: 'ALL', value: null },
    specialty: { label: 'ALL', value: null },
    head_id: '',
    manager_id: '',
    rep_id: { label: 'ALL', value: null },
    from: moment().format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
  };

  const { onSetTitle } = useContext(AppConst.AppContext);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [reportData, setReportData] = useState([]);
  const [totalData, setTotalData] = useState([]);
  const [loading, setLoading] = useState(true);

  onSetTitle('Product Sampling Inventory');

  const getData = async () => {
    try {
      // toast.loading('Please wait ...');
      setLoading(true);
      const request = {
        department: '',
        head_id: '',
        manager_id: '',
        rep_id: filterForm?.rep_id?.value,
        from: moment(filterForm?.from).format('YYYY-MM-DD'),
        to: moment(filterForm?.to).format('YYYY-MM-DD'),
        specialty: filterForm?.specialty?.value ? [filterForm?.specialty?.value] : [],
        team: filterForm?.team?.value ? [filterForm?.team?.value] : [],
      };

      const res = await getProductSamplingMaintenanceInventoryReport(request);

      const { code, data, total } = res.data;

      if (code === '200') {
        setReportData(data);
        setTotalData(total);
        console.log(reportData);
      }
      toast.dismiss();
      setLoading(false);
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <useSamplingContext.Provider
        value={useMemo(() => ({
          setFilterForm,
          filterForm,
          defaultFilter,
          reportData,
          setReportData,
          totalData,
          setTotalData,
          getData,
          loading,
        }))}
      >
        <Box sx={{ backgroundColor: '#fff', boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Grid container spacing={2} justifyContent='flex-end'>
            {/* table */}
            <Grid item xs={12}>
              <Table />
            </Grid>
          </Grid>
          <Grid container justifyContent='flex-end'>
            {/* total */}
            <Grid item xs={12} md={6} mdOffset={6}>
              <TotalTable />
            </Grid>
          </Grid>
        </Box>
      </useSamplingContext.Provider>
    </div>
  );
}
